export const getPlaceholder = (minValue: number, maxValue: number) => {
  const newMinValue = Math.floor(minValue);
  const newMaxValue = Math.ceil(maxValue);
  return [newMinValue, newMaxValue];
};
